export default __webpack_public_path__ + "images/cloud-blue-60.png";